export default __webpack_public_path__ + "e1754981374d69cb365f4f0ed6ba0f12.png";